import { Checkbox, Col, Form, Row } from "antd";
import React, { useEffect, useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import {
  DeleteOutlined,
  PlusCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import UploadInput from "../../../../biblio/Inputs/UploadInput";
import { convertFileToBase64 } from "../../../../components/utils/utils";

interface MaterialStituationProps {
  incomeSources: any;
  orphanCount: number;
  form: any;
}

const MaterialStituationInfo = ({
  incomeSources,
  form,
  orphanCount,
}: MaterialStituationProps) => {
  const [showExtraInputs, setShowExtraInputs] = useState<boolean>(false);
  const [blocks, setBlocks] = useState<
    Array<{
      source_income_id: number;
      amount: number;
      attachment_ids: { filename: string; data: string }[];
      beneficiaries_number: number;
      fileList: any[];
    }>
  >([
    {
      source_income_id: 0,
      amount: 0,
      attachment_ids: [],
      beneficiaries_number: orphanCount,
      fileList: [],
    },
  ]);

  const addBlock = () => {
    const newBlock = {
      source_income_id: 0,
      amount: 0,
      attachment_ids: [],
      beneficiaries_number: orphanCount,
      fileList: [],
    };
    form.setFieldValue("beneficiaries_number" + blocks.length, orphanCount);
    setBlocks([...blocks, newBlock]);
  };

  const handleCheckboxChange = (e: any) => {
    setShowExtraInputs(e.target.checked);
    form.setFieldValue("has_debt", e.target.checked);
  };

  const handleFileChange = async (fileList: any[], index: number) => {
    const file = fileList[0]?.originFileObj;

    if (file) {
      try {
        const base64 = (await convertFileToBase64(file)) as string;
        const imageData = {
          filename: file.name,
          data: base64,
        };

        const updatedBlocks = [...blocks];
        updatedBlocks[index].attachment_ids = [imageData];
        updatedBlocks[index].fileList = fileList;
        setBlocks(updatedBlocks);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  useEffect(() => {
    const materialStateData = blocks.map((block, index) => ({
      source_income_id: block.source_income_id,
      amount: block.amount,
      attachment_ids: block.attachment_ids,
      beneficiaries_number: block.beneficiaries_number,
    }));

    form.setFieldValue("material_state_ids", materialStateData);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blocks]);

  const onChange = (
    value: any,
    key:
      | "source_income_id"
      | "amount"
      | "attachment_ids"
      | "beneficiaries_number",
    index: number
  ) => {
    const l__bloks = [...blocks];
    if (key === "source_income_id") {
      l__bloks[index][key] = value.value;
    } else {
      l__bloks[index][key] = value;
    }

    setBlocks(l__bloks);
  };

  const removeItem = (index: number) => {
    const updatedBlocks = [...blocks];
    updatedBlocks.splice(index, 1);
    let json: any = {};

    updatedBlocks.forEach((el: any, index: number) => {
      json["source_income_id" + index] =
        el.source_income_id !== 0 ? el.source_income_id : "";
      json["amount" + index] = el.amount;
      json["attachment_ids" + index] = el.attachment_ids;
      json["beneficiaries_number" + index] = el.beneficiaries_number;
    });
    console.log(form.getFieldValue("has_debt"));
    json = {
      ...json,
      has_debt: form.getFieldValue("has_debt"),
      debt_amount: form.getFieldValue("debt_amount"),
      debt_reason: form.getFieldValue("debt_reason"),
    };
    form.resetFields();
    form.setFieldsValue(json);
    setBlocks(updatedBlocks);
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>معلومات عن الحالة المادية عن الأسرة</span>
      </div>
      {blocks.map((block, index) => (
        <Row gutter={16} key={index}>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`source_income_id${index}`}
              label="المصدر"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{
                className: "takaful--label-style",
              }}
            >
              <Selects
                options={incomeSources?.data}
                onChange={(e) => onChange(e, "source_income_id", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`amount${index}`}
              label="المبلغ"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs
                type="tel"
                onChange={(e) => onChange(e.target.value, "amount", index)}
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`beneficiaries_number${index}`}
              label="عدد المستفيدين"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  validator: (_, value) => {
                    if (!value || value > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("فقط الأرقام الموجبة مسموح بها!")
                    );
                  },
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs
                type="tel"
                defaultValue={orphanCount}
                onChange={(e) =>
                  onChange(e.target.value, "beneficiaries_number", index)
                }
              />
            </Form.Item>
          </Col>
          <Col xxl={5} xl={5} lg={5} md={5} sm={20} xs={20}>
            <Form.Item
              name={`attachment_ids${index}`}
              label="مرفقات"
              labelCol={{ className: "takaful--label-style" }}
            >
              <UploadInput
                accept="*"
                text="تحميل مرفقات"
                icon={<UploadOutlined />}
                multiple={false}
                onChange={(fileList) => handleFileChange(fileList, index)}
                maxCount={1}
                list={block.fileList}
              />
            </Form.Item>
          </Col>

          <Col xxl={1} xl={1} lg={4} md={4} sm={4} xs={4}>
            {blocks.length > 1 && (
              <Form.Item
                name={`remove${index}`}
                label=" "
                labelCol={{ className: "takaful--label-style" }}
              >
                <PrimaryButton
                  title=""
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
      ))}

      <Col
        className="takaful--button-material"
        xxl={2}
        xl={2}
        lg={4}
        md={4}
        sm={24}
        xs={24}
      >
        <PrimaryButton
          title="إضافة مصدر دخل"
          icon={<PlusCircleOutlined />}
          onClick={() => addBlock()}
          className="takaful--primary-button-info"
        />
      </Col>

      <Row gutter={16} style={{ marginTop: "2vh" }}>
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <Form.Item name="has_debt" valuePropName="has_debt">
            <Checkbox
              checked={form.getFieldValue("has_debt") ?? false}
              onChange={handleCheckboxChange}
            >
              <span className="takaful--check-style">لديها ديون</span>
            </Checkbox>
          </Form.Item>
        </Col>
        {showExtraInputs && (
          <>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="debt_amount"
                label="مقدار الديون"
                rules={[
                  {
                    required: showExtraInputs,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="tel" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="debt_reason"
                label="سبب الديون"
                rules={[
                  {
                    required: showExtraInputs,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
          </>
        )}
      </Row>
    </>
  );
};

export default MaterialStituationInfo;
